import AdminModel from 'admin_panel/imports/models.admin_import';
import AdminHeader from '../../admin_common_components/ui/admin_header/admin_header';
import ListComponent from '../../admin_common_components/ui/list_component/list_component';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery, useSetState } from 'utils/functions.utils';
import { Dropdown, Functions, PrimaryButton, Searchbar, SingleDatePicker } from 'utils/imports.utils';
import Sidebar from '../../admin_common_components/ui/sidebar/sidebar_component.ui';
import './bookings.admin_screen.scss';
import moment from 'moment';
import _ from 'lodash';
import * as XLSX from 'xlsx';

const Bookings = (props: any) => {
  const [state, setState] = useSetState({
    booking_data: [],
    search_status: '',
    search_input: '',
    search_data: [],
    skip:0,
    limit:100,
    search:'',
    export_modal: false,
    export_start_date: null,
    export_end_date: null,
  });

  // query
  const query = useQuery();
  const params_id = query.get('id') || '';

  // getManybooking
  const getManybookings = async () => {
    Functions.notiflixLoader();
    try {
      const body:any = {
        limit:state.limit,
        skip:state.skip
      }
      if (state.search.length > 0) {
        const search = parseInt(state.search);
        if (search) {
          body['search'] = search;
        } else {
          body['search_name'] = state.search;
        }
      }
      if(state.search_status) {
        delete body.search
        delete body.search_name
        body['search_status'] = state.search_status.value
      }
      const res: any = await AdminModel.bookings.getManyBookingWithLimit(body);
      setState({booking_data:res.data.docs})
    } catch (error: any) {
      Functions.notiflixFailure(error);
    } finally {
      Functions.notiflixRemove();
    }
  };

  
  useEffect(() => {
    getManybookings()
  }, [state.search,state.search_status]);

  const exportBookingsToExcel = async () => {
    if (!state.export_start_date || !state.export_end_date) {
      Functions.notiflixFailure('Please select both start date and end date');
      return;
    }

    if (moment(state.export_start_date).isAfter(moment(state.export_end_date))) {
      Functions.notiflixFailure('Start date cannot be greater than end date');
      return;
    }

    const exportStartDate = moment(state.export_start_date).startOf('day');
    const exportEndDate = moment(state.export_end_date).endOf('day');

    Functions.notiflixLoader();
    try {
      const body: any = {
        limit: 10000,
        skip: 0,
        startDate: exportStartDate.toISOString(),
        endDate: exportEndDate.toISOString(),
      };

      if (state.search.length > 0) {
        const search = parseInt(state.search);
        if (search) {
          body.search = search;
        } else {
          body.search_name = state.search;
        }
      }

      if (state.search_status) {
        delete body.search;
        delete body.search_name;
        body.search_status = state.search_status.value;
      }

      const res: any = await AdminModel.bookings.getManyBookingWithLimit(body);
      const bookings = (res?.data?.docs || []).filter((booking: any) => {
        if (!booking?.created_at) {
          return false;
        }

        const bookingDate = moment(booking.created_at);
        return bookingDate.isValid() && bookingDate.isBetween(exportStartDate, exportEndDate, undefined, '[]');
      });

      if (!bookings.length) {
        Functions.notiflixFailure('No bookings found for the selected date range');
        return;
      }

      const rows = bookings.map((booking: any) => ({
        'Order ID': booking?.id || booking?._id || '---',
        'Pleater Name': booking?.pleater?.name || '---',
        'No. Sarees': booking?.quantity ?? '---',
        Date: booking?.created_at
          ? moment(booking.created_at).format('DD-MM-YYYY')
          : '---',
        'Customer Name': booking?.user?.name || '---',
      }));

      const worksheet = XLSX.utils.json_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Bookings');
      const fileName = `bookings-report-${moment().format('YYYYMMDD-HHmmss')}.xlsx`;
      XLSX.writeFile(workbook, fileName);
      setState({ export_modal: false });
    } catch (error: any) {
      Functions.notiflixFailure(error);
    } finally {
      Functions.notiflixRemove();
    }
  };


  const titledata: any = [
    {
      label: '#',
      value: 's.no',
      width: '5%',
    },
    {
      label: 'Order ID',
      value: 'id',
      width: '12%',
    },
    {
      label: 'Date',
      value: 'created_at',
      width: '15%',
    },
    {
      label: 'Customer',
      value: 'name',
      width: '16%',
      key:'user',
      isNested:true
    },
    {
      label: 'Pleater',
      value: 'name',
      width: '16%',
      key:'pleater',
      isNested:true
    },
    {
      label: 'Status',
      value: 'status',
      width: '20%',
    },
  ];
  const paymentMethod: any = [
    {
      value: '',
      label: 'All',
    },
    {
      value: 'ORDER PLACED',
      label: 'Order Placed',
    },
    {
      value: 'WAITING FOR PICKUP',
      label: 'Waiting For Pickup',
    },
    {
      value: 'PICKED UP',
      label: 'Picked Up',
    },
    {
      value: 'REACHED',
      label: 'Reached',
    },
    {
      value: 'WAITING FOR DISPATCH',
      label: 'Waiting For Dispatch',
    },
    {
      value: 'DISPATCH',
      label: 'Dispatch',
    },
    {
      value: 'DELIVERED',
      label: 'Delivered',
    },
    {
      value: 'PICKUP SCHEDULED',
      label: 'Pickup Scheduled',
    },
    {
      value: 'DROP SCHEDULED',
      label: 'Drop Scheduled',
    },
    {
      value: 'REFUND INITIATED',
      label: 'Refund Initiated',
    },
    {
      value: 'REFUNDED',
      label: 'Refund',
    },
    {
      value: 'ORDER CANCELLED',
      label: 'Order Cancelled',
    },
    {
      value: 'QUEUED',
      label: 'Queued',
    },
  ];

  const navigate = useNavigate();
  useEffect(() => {
    if (!localStorage.token) {
      navigate('/login');
    }
  }, []);

  return (
    <div className="bookings_container">
      <div className="sidebar-header">
        <Sidebar />
      </div>
      <div className="bookings_wrapper">
        <AdminHeader text={'Bookings'} />
        <div className="bookings_table_container">
          <div className="table_header">
            <div className="search_wrapper">
              <Searchbar
                className={'search_panel'}
                value={state.search}
                onChange={(value: any) => setState({ search: value ,search_status:''})}
                placeholder={'Search'}
                style={{ borderRadius: '16px' }}
              />
            </div>
            <div className="dropdown_header">
              <Dropdown
                data={paymentMethod}
                value={state.search_status}
                onChange={(search: any) =>
                  setState({ search_status:search})
                }
                width={'220px'}
                borderRadius={'15px'}
                placeholder={'Status...'}
              />
              <PrimaryButton
                text={'Export'}
                onClick={() => setState({ export_modal: true })}
                backgroundColor={'#A1342D'}
                color={'#FFFFFF'}
                width={'120px'}
                height={'40px'}
                style={{ borderRadius: '10px', marginLeft: '12px', cursor: 'pointer' }}
              />
            </div>
          </div>
          <ListComponent
            titleArray={titledata}
            type={'booking_table'}
            data={state.booking_data}
          />
        </div>
      </div>
      {state.export_modal && (
        <div className="export_modal_overlay">
          <div className="export_modal_container">
            <div className="export_modal_title">Export Booking Report</div>
            <div className="export_modal_date_fields">
              <SingleDatePicker
                value={state.export_start_date}
                placeholder={'Start Date'}
                onChange={(value: any) => setState({ export_start_date: value })}
                iconOnPress={() => setState({ export_start_date: null })}
                onFocusPress={() => setState({ export_start_date: null })}
              />
              <SingleDatePicker
                value={state.export_end_date}
                placeholder={'End Date'}
                onChange={(value: any) => setState({ export_end_date: value })}
                iconOnPress={() => setState({ export_end_date: null })}
                onFocusPress={() => setState({ export_end_date: null })}
              />
            </div>
            <div className="export_modal_actions">
              <PrimaryButton
                text={'Cancel'}
                onClick={() =>
                  setState({
                    export_modal: false,
                    export_start_date: null,
                    export_end_date: null,
                  })
                }
                backgroundColor={'#F2F2F2'}
                color={'#768089'}
                width={'120px'}
                height={'40px'}
                style={{ borderRadius: '10px', cursor: 'pointer' }}
              />
              <PrimaryButton
                text={'Download'}
                onClick={exportBookingsToExcel}
                backgroundColor={'#A1342D'}
                color={'#FFFFFF'}
                width={'120px'}
                height={'40px'}
                style={{ borderRadius: '10px', cursor: 'pointer' }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Bookings;
